import { BASE_URL } from '../endpoints'
import { del, get, patch, post } from '../https'

export const getAllSchools = (): Promise<unknown> => {
  return get(`${BASE_URL}/super/schools`)
}

export const getAllUsers = (page: number): Promise<unknown> => {
  return get(`${BASE_URL}/super/users/schools?page=${page}&limit=7`)
}

export const getAllGroupUsers = (page: number): Promise<unknown> => {
  return get(`${BASE_URL}/super/users/groups?page=${page}&limit=7`)
}

export interface createUserType {
  firstName: string
  lastName: string
  role: string
  email?: string
  groupId?: string
  sendInvitationEmail: boolean
}

export const createUserApi = (
  data: createUserType,
  sid: string
): Promise<unknown> => {
  return post(`${BASE_URL}/super/schools/${sid}/users`, data, null)
}
export const updateUserApi = (
  data: createUserType,
  sid: string,
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/super/schools/${sid}/users/${id}`, data, null)
}
export const createGroupUserApi = (
  data: createUserType,
  sid: string
): Promise<unknown> => {
  return post(`${BASE_URL}/super/groups/${sid}/users`, data, null)
}
export const updateGroupUserApi = (
  data: createUserType,
  sid: string,
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/super/groups/${sid}/users/${id}`, data, null)
}

export const resendVerificationEmail = (
  sid: string,
  id: string
): Promise<unknown> => {
  return patch(
    `${BASE_URL}/super/schools/${sid}/users/${id}/resend-verification-email`,
    null
  )
}
export const resendVerificationEmailGroups = (
  sid: string,
  id: string
): Promise<unknown> => {
  return patch(
    `${BASE_URL}/super/groups/${sid}/users/${id}/resend-verification-email`,
    null
  )
}

export const deleteGroupUser = ({
  id,
  uid,
}: {
  id: string | undefined
  uid: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/super/groups/${id}/users/${uid}`, null)
}
export const deleteSchoolUser = ({
  id,
  uid,
}: {
  id: string | undefined
  uid: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/super/schools/${id}/users/${uid}`, null)
}
